import { Link } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher';

// Top of the order flow. Deliberately no link back to the homepage while
// ordering - inside the flow you only move between its own steps. Finished
// steps can be clicked to go back; later ones can't be skipped to. The pages
// around the flow (thank-you, order status, join) pass `home`: there the logo
// goes to the homepage, like everywhere else on the site.
function OrderHeader({ step, steps, onGoTo, stepOfLabel, home = false }) {
  const brand = (
    <>
      <img className="brand-logo" src="/logo.svg" alt="myMosaik" />
    </>
  );

  return (
    <header className="of-header">
      {home ? (
        <Link to="/" className="of-brand of-brand--link">
          {brand}
        </Link>
      ) : (
        <span className="of-brand">{brand}</span>
      )}

      {steps && (
        <>
          <ol className="of-steps">
            {steps.map((label, i) => {
              const n = i + 1;
              const state = n === step ? 'is-current' : n < step ? 'is-done' : '';
              return (
                <li key={label} className={`of-step ${state}`}>
                  <button
                    type="button"
                    onClick={() => n < step && onGoTo(n)}
                    disabled={n >= step}
                    aria-current={n === step ? 'step' : undefined}
                  >
                    <span className="of-step-num">0{n}</span>
                    {label}
                  </button>
                </li>
              );
            })}
          </ol>
          <p className="of-steps-compact">{stepOfLabel}</p>
        </>
      )}

      <LanguageSwitcher />
    </header>
  );
}

export default OrderHeader;
